/*
Translation handling in JS

If a translation is missing a placeholder is provided
If the translation is use on the whole website, update translations keys list in Nav/Core/Shared/_JavaScriptConfiguration.cshtml
Else in the header of the page where the JS use that translation, provide the parameter translationsKeys to the HtmlHelper.RenderJsConfig()
 */

const translations = {};
for(const translationsElement of document.getElementsByClassName("js-translations")){
  try{
    Object.assign(translations, JSON.parse(translationsElement.text));
  }catch(error){
    console.error(error);
  }
}

export default (key = "", ...data) => {
  key = key.toLowerCase();
  if(translations.hasOwnProperty(key)){
    return translations[key].replace(/{(\d+)}/, (match, index) => {
      const value = data[parseInt(index)];
      return value === undefined || value === null ? "" : value;
    });
  }

  return `[translation "${key}"${data.map(value => ` "${String(value).replace(/"/g, "\\$&")}"`).join("")}]`;
}
